
  <div>
    <VueFileAgent
      ref="fileAgent"
      :multiple="true"
      :deletable="true"
      :meta="true"
      :accept="'video/*'"
      :maxSize="maxSize"
      :maxFiles="1"
      :helpText="selectText"
      :readonly="isReadOnly"
      :errorText="{
        type:errorMessage,
        size: errorSize,
      }"
      :thumbnailSize="120"
      :theme="'list'"
      v-model="fileRecords"
      @select="filesSelected($event)"
      @beforedelete="onBeforeDelete($event)"
      @delete="onDelete($event)"
    ></VueFileAgent>
    <k-progress type="line" :percent="percentCnt"></k-progress>

    <p class="txt_input">
      * 동영상 파일은 400MB까지 첨부가능합니다.
    </p>
    <span>{{ videoUploadRes.resText }}</span>

    <!-- 썸네일 목록 -->
    <div v-if="thumFileList != null && thumFileList.length > 0" >
      <div class="pd_t10 tit">
        <b>대표 이미지를 선택해 주세요.</b>
<!--        pick_thum_uid = {{ pick_thum_uid }}-->
      </div>
      <div v-for="(titem) in thumFileList" style="display: inline-block; cursor: pointer;" >
        <p class="check_row mg_t5 mg_b5">
          <input type="radio" v-model="pick_thum_uid" :value="titem.cmm_uid" :id="titem.cmm_uid" hidden="hidden">
          <label for="price1" tabindex="600" @keydown.enter="$('#price1').trigger('click');">
            <img
              v-bind:src="titem.file_path"
              width="210px"
              height="370px"
              @click="onClickThum(titem.cmm_uid)"
            >
          </label>
        </p>
<!--        :style="titem.cmm_uid === pick_thum_uid ? 'border: 10px solid red;' : ''"-->
      </div>
    </div>

    <div class="pd_t10">
      대표 이미지 직접 업로드
      <VueFileAgent
        ref="imgFileAgent"
        :multiple="true"
        :deletable="true"
        :meta="true"
        :accept="'image/*'"
        :maxSize="'2048MB'"
        :maxFiles="1"
        helpText="이미지 파일을 선택해 주세요."
        :errorText="{
          type: imgErrorMessage,
          size: imgErrorSize,
        }"
        :thumbnailSize="120"
        :theme="'list'"
        v-model="imgFileRecords"
        @select="filesImgSelected($event)"
        @beforedelete="onBeforeImgDelete($event)"
      ></VueFileAgent>
    </div>

  </div>
